import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatRadioButton } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
  standalone: true,
  imports: [MatRadioButton, CommonModule, TranslateModule, MatTableModule],
})
//Componente para mostrar un arreglo de un objeto con el estilo Einteligent
//Incluye encabezados sticky, paginador Einteligent y se puede cargar la información desde un componente padre usando data, columns y displayColumns
//name y hasButton son opciones extras
//Estilos personalizados para columnas especificas desde una implementación se pueden poner por medio de un ::ng-deep .mat-column-nombreDcolumna a personalizar en su css
export class GridComponent implements OnInit, OnChanges {
  @Input() data!: any[]; //arreglo de objetos que se quiere mostrar en el mat-table
  @Input() columns!: string[]; //Arreglo con los nombres de las columnas de acuerdo a los campos del objeto fila que se mostrará en la tabla ex. name
  @Input() displayColumns!: string[][]; //Arreglo con los nombres y tipo de dato (string "", moneda "$" y porcentaje "%") de las columnas que se mostraran (En el orden correspondiente al anterior arreglo) ex. ["Nombre",""]
  @Input() dataSource!: MatTableDataSource<any>; //Datasource para el uso del mat-table se ajusta dinamicamente de acuerdo a la data
  @Input() name!: string; //nombre del archivo que se genera con el botón del paginador, si se deja nulo o vacio no muestra dicho botón
  @Input() hasButton: boolean = false; //indicador de que la primera columna por fila tiene un botón con el que interactuar ex. para abrir un pop-up con detalles
  @Input() isRadio: number = -1; //opción seleccionada de un radio button, se manda 0 significa que no hay seleccionado nada y aparecen radio buttons
  @Input() pageSizeOptions: number[] = [5, 10, 25, 50];
  @Input() pageSize: number = 10;
  @Output() mainButtonEvent = new EventEmitter<any>(); //evento cuando el botón es presionado (si esta activado)

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.dataSource = new MatTableDataSource(this.data);
    }
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.data);
  }

  mainButtonPress(value: any) {
    this.mainButtonEvent.emit(value);
  }
}
